import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { viewTypes } from './view-types.js';

import DateView      from './date-view.jsx';
import MonthView     from './month-view.jsx';
import YearView      from './year-view.jsx';

import './calendar.scss';

class Calendar extends React.Component {
    slide = '';

    constructor( props ) {
        super( props );

        let year, month;

        const value = this.props.value;

        if ( this.isDate( value ) ) {
           year = value.getFullYear();
           month = value.getMonth();
        } else {
            const today = new Date();
            year = today.getFullYear();
            month = today.getMonth();
        }

        this.state = {
            view: viewTypes.date,
            prevView: viewTypes.date,
            year: year,
            prevYear: year,
            month: month,
            prevMonth: month,
            ...props.__testState
        };
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        const value = nextProps.value;

        if ( this.isDate( value ) ) {
            const year = value.getFullYear();
            const month = value.getMonth();

            this.setState( {
                year: year,
                prevYear: this.state.year,
                month: month,
                prevMonth: this.state.month
            } );
        }
    }

    isDate = ( value ) => {
        return ( value && typeof value === 'object' &&
            typeof value.getFullYear === 'function' &&
            typeof value.getMonth === 'function' );
    };

    handleViewChange = ( view, year, month ) => {
        this.setState( {
            view: view,
            prevView: this.state.view,
            year: year,
            prevYear: this.state.year,
            month: month,
            prevMonth: this.state.month
        } );
    };

    render() {
        let viewComponent = null;

        const {
            value,
            fromValue,
            toValue,
            onChange,
            onFromChange,
            onToChange,
            ariaLabels
        } = this.props;
        const {
            view,
            prevView,
            year,
            prevYear,
            month,
            prevMonth
        } = this.state;

        if ( prevView === view ) {
            if ( prevYear < year ) {
                this.slide = 'next';
            } else if ( prevYear > year ) {
                this.slide = 'prev';
            } else if ( month < prevMonth ) {
                this.slide = 'prev';
            } else if ( month > prevMonth ) {
                this.slide = 'next';
            }
        }

        switch ( view ) {
            case viewTypes.date:
                viewComponent =
                    <CSSTransitionGroup key={ view }
                        className={ 'slide-container ' + this.slide }
                        transitionName="slide-animate"
                        transitionEnterTimeout={ 400 }
                        transitionLeaveTimeout={ 400 } >
                        <DateView key={ this.state.year + '-' + this.state.month }
                            locale={ this.props.locale }
                            year={ this.state.year } month={ this.state.month }
                            onViewChange={ this.handleViewChange }
                            value={ value } onChange={ onChange }
                            toValue={ toValue } onToChange={ onToChange }
                            fromValue={ fromValue } onFromChange={ onFromChange }
                            hasActivity={ this.props.hasActivity }
                            ariaLabels={ ariaLabels } />
                    </CSSTransitionGroup>;

                break;
            case viewTypes.month:
                viewComponent =
                    <CSSTransitionGroup key={ view }
                        className={ 'slide-container ' + this.slide }
                        transitionName="slide-animate"
                        transitionEnterTimeout={ 400 }
                        transitionLeaveTimeout={ 400 }>
                        <MonthView key={ this.state.year + '-' + this.state.month }
                            locale={ this.props.locale }
                            year={ year } month={ month }
                            onViewChange={ this.handleViewChange }
                            value={ value } onChange={ onChange }
                            hasActivity={ this.props.hasActivity }
                            ariaLabels={ ariaLabels } />
                    </CSSTransitionGroup>;
                break;
            case viewTypes.year:
                viewComponent =
                    <CSSTransitionGroup key={ view }
                        className={ 'slide-container ' + this.slide }
                        transitionName="slide-animate"
                        transitionEnterTimeout={ 400 }
                        transitionLeaveTimeout={ 400 }>
                        <YearView key={ this.state.year + '-' + this.state.month }
                            locale={ this.props.locale }
                            year={ year } month={ month }
                            onViewChange={ this.handleViewChange }
                            value={ value } onChange={ onChange }
                            hasActivity={ this.props.hasActivity }
                            ariaLabels={ ariaLabels } />
                    </CSSTransitionGroup>;
                break;
            default:
                break;
        }

        return <CSSTransitionGroup className="calendar"
            transitionName="view-animate"
            transitionEnterTimeout={ 400 }
            transitionLeaveTimeout={ 400 }>
            { viewComponent }
        </CSSTransitionGroup>;
    }
}

export default Calendar;
